export default '/build/f11958be.svg'